import type { RentalPayment, RentalPaymentResult } from "@/domain/rental";
import { apiClient } from "@/v2/apis/apiClient";

/**
 * The legacy custom-payment fine call, kept for the v1 dashboard only.
 *
 * It lives here rather than beside the other rental APIs because those are
 * re-exported wholesale into v2, and LISA-553 requires that v2 contain no call
 * to this endpoint — fines there go through the monorepo fine API instead. The
 * v1 implementation is out of that ticket's scope and is left working.
 */
export const payForRental = (
  rentalId: number,
  data: RentalPayment
): Promise<RentalPaymentResult> => {
  return apiClient
    .post(
      `/journey-service/dashboard/journeys/${rentalId}/payment/custom`,
      data
    )
    .then((r) => r.data);
};
